module.exports = __webpack_public_path__ + "media/img/help_center/Institution_Applications_04-41a0fef382209ff56ec04f6b7c58b834.jpg";